let lenis = null;

export const setLenis = (instance) => {
  lenis = instance;
};

export const scrollToSection = (target) => {
  if (lenis) {
    lenis.scrollTo(target, { offset: -72, duration: 1.4 });
  } else if (typeof target === "number") {
    window.scrollTo({ top: target, behavior: "smooth" });
  } else {
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  }
};
